'use client'

import type { PLTypedWidgetProps } from '@src/components/pl-base-widget'
import { SanitizedHtml } from '@src/quince-site-pdp/src/organisms/productPageSections/disclaimer'

import type { DisclaimerWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

/**
 * DISCLAIMER widget adapter (PL PDP).
 *
 * Adapter that extracts disclaimer data and delegates to SanitizedHtml component
 * for safe HTML rendering with sanitization.
 */
const DisclaimerWidgetComponent = (props: PLTypedWidgetProps<DisclaimerWidgetData>) => {
  const disclaimerText = props.data.disclaimerData?.text
  return <SanitizedHtml html={disclaimerText} />
}

export { DisclaimerWidgetComponent }
